import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { CreateChancel, ValidationInput,SelectType, modalsStyle } from 'components';
import { ErrorText, FindLoad, FindSuccess, useGlobalStyles, useGlobalTextStyles, useModal } from 'utils';
import { customerActions, customerPaymentActions, httpRequestsOnSuccessActions } from 'store';
import { paymentMethods, sourceEnum, sourceList } from './constants';

const ACTION_TYPE = 'CREATE_CUSTOMER_PAYMENT';
export const AddCustomerPayment = ({ afterSuccess }) => {
  const { customersList } = useSelector((state) => ({
    customersList: state.customers.customersList,
  }));
  const globalStyles = useGlobalStyles();
  const classes = modalsStyle();
  const globalText = useGlobalTextStyles();
  const dispatch = useDispatch();
  const loader = FindLoad(ACTION_TYPE);
  const success = FindSuccess(ACTION_TYPE);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const { close } = useModal();

  useEffect(() => {
    dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
    // dispatch(factoringActions.getFactorings({status: 'ACTIVE'}))
  }, []);

  useEffect(() => {
    if (success.length) {
      afterSuccess();
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      close();
    }
  }, [success]);
  const handleCreate = () => {
    if (inputs.pmtDate && inputs?.source && inputs.reference && inputs.pmtMethod && inputs.amount) {
      const date = {
        amount: +inputs.amount,
        factoring: inputs.factoring,
        pmtMethod: inputs.pmtMethod,
        customer: inputs.customer,
        reference: inputs.reference,
        source: inputs.source,
        pmtDate: moment(inputs.pmtDate).format('YYYY-MM-DD'),
      };
      if(inputs?.source === sourceEnum.OTHER){
        inputs?.sourceDescription ? date.sourceDescription = inputs.sourceDescription : delete date.sourceDescription;
      }else{
        date.sourceDescription = null
      }
      dispatch(customerPaymentActions.createCustomerPayment(date));
    } else {
      setError(
        !inputs.pmtDate ? 'pmtDate' :
          !inputs.source ? 'source' :
            !inputs.reference ? 'reference' :
              !inputs.pmtMethod ? 'pmtMethod' :
                !inputs.amount ? 'amount' :
                  '',
      );
    }
  };
  const handleChange = e => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
  };

  return (
    <div className={classes.payroll}>
      <div>
        <p className={globalText.modalTitle} style={{ marginBottom: 24 }}>{'Add Customer Payment'}</p>
        <ValidationInput
          variant={'outlined'}
          onChange={handleChange}
          value={inputs.pmtDate}
          type={'date'}
          label={'Date*'}
          name="pmtDate"
          typeError={error === 'pmtDate' && ErrorText.field}
          className={inputs?.pmtDate && globalStyles.inputTextFieldBlue}
        />
        <SelectType
          title={'Source*'}
          name={'source'}
          handleSelect={handleChange}
          defaultValue={inputs.source}
          list={sourceList}
          error={error}
          typeError={error === 'source' ? `Customer is required` : ''}
          renderValue={(i) => i?.name}
        />
        {inputs.source === sourceEnum.OTHER &&
          <ValidationInput
            variant={'outlined'}
            name={'sourceDescription'}
            label={'Description'}
            type={'text'}
            typeError={error === 'sourceDescription' ? ErrorText.field : ''}
            onChange={handleChange}
            value={inputs.sourceDescription}
            className={inputs?.sourceDescription && globalStyles.inputTextFieldBlue}
          />
        }
        <SelectType
          loadType={'GET_CUSTOMERS'}
          title={'Customers'}
          name={'customer'}
          handleSelect={handleChange}
          defaultValue={inputs.customer}
          list={customersList?.customers || []}
          error={error}
          typeError={error === 'customer' ? `Customer is required` : ''}
          renderValue={(i) => i?.name}
        />
        <ValidationInput
          variant={'outlined'}
          name={'reference'}
          label={'Reference Number*'}
          type={'text'}
          typeError={error === 'reference' ? ErrorText.field : ''}
          onChange={handleChange}
          value={inputs.reference}
          className={inputs?.reference && globalStyles.inputTextFieldBlue}
        />
        <div className={globalStyles.flexAble} style={{ gap: 24 }}>
          <div style={{ width: '50%' }}>
            <SelectType
              title={'Payment Method*'}
              name={'pmtMethod'}
              handleSelect={handleChange}
              defaultValue={inputs.pmtMethod}
              list={paymentMethods}
              error={error}
              typeError={error === 'pmtMethod' ? `Customer is required` : ''}
              renderValue={(i) => i?.name}
            />
          </div>
          <div style={{ width: '50%' }}>
            <ValidationInput
              variant={'outlined'}
              name={'amount'}
              label={'Amount*'}
              type={'number'}
              typeError={error === 'amount' ? ErrorText.field : ''}
              onChange={handleChange}
              value={inputs.amount}
              className={inputs?.amount && globalStyles.inputTextFieldBlue}
            />
          </div>
        </div>
        <div className={classes.createChancel}>
          <CreateChancel
            loader={!!loader.length}
            classes={globalStyles.buttonsStyle}
            create={'Add Payment'}
            chancel={'Cancel'}
            onCreate={handleCreate}
            onClose={() => close()}
            width={'100%'}
          />
        </div>
      </div>
    </div>
  );
};